import {companyData} from "../../global/change-company";
import {estimateApprovalRow} from "./models";
import {clickableGridRows} from "../../kendo-functions";
import {gridSettings} from "../../kendo-defaults";
import {
    getPendingApprovals,
    getPendingApprovalString,
    sortByApprovals,
    statusTemplate
} from "../../data/approvals";

const pendingFilter = {
    filters: [],
    logic: 'or',
    forField: 'PendingApprovals'
};
const myCreatedFilter = {
    filters: [],
    logic: 'and',
    forField: 'CreatedBy'
};
const filterRoles = [];

let isGridInit = false;
let isCreateNewInit = false;
let estimateApprovalGrid = $('.js-estimate-approval-grid');

const estimateApprovalDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: 'EstimateApprovals',
            dataType: 'json',
            data() {
                return {
                    branchId: companyData.id
                }
            }
        }
    },
    schema: {
        model: estimateApprovalRow,
        parse(r) {
            if (r.length < 0) return;
            for (const item of r) {
                if (item.Approvals === '') item.Approvals = '[]';
                item.Approvals = JSON.parse(item.Approvals);

                if (item.Attendees === '') item.Attendees = '[]';
                item.Attendees = JSON.parse(item.Attendees);

                if (item.RequiredAttendees === '') item.RequiredAttendees = '[]';
                item.RequiredAttendees = JSON.parse(item.RequiredAttendees);

                item.RequiredAttendees = item.RequiredAttendees.filter(a => a.empNum)

                const attendees = item.RequiredAttendees.length !== 5 ? item.Attendees : item.RequiredAttendees;

                // item.PendingApprovals = getPendingApprovalString(item.Attendees, item.Approvals);
                item.PendingApprovals = getPendingApprovalString(attendees, item.Approvals);

                if (item.Approvals.length === item.Attendees.length && item.Status !== 'Saved') item.Status = 'Approved';
            }
            return sortByApprovals(r);
        }
    },
    pageSize: 20
});

const estimateApprovalColumns = [{
    field: 'DisplayId',
    title: 'Request ID'
}, {
    field: 'CreatedOn',
    title: 'Created On',
    format: '{0:M/d/yyyy}'
}, {
    field: 'CreatedBy',
    title: 'Requested By'
}, {
    field: 'ProjectName',
    title: 'ProjectName'
}, {
    field: 'status',
    title: 'Request Status',
    template: statusTemplate
}];

const openEstimateApproval = (e) => {
    const dre = $(e.target).closest('tr[role="row"]');
    const dr = estimateApprovalGrid.dataItem(dre);
    $.redirect({
        url: 'Info',
        values: {
            Id: dr.Id
        }
    });
};

const newEstimateApproval = (e) => {
    $.redirect({
        url: 'Info'
    });
};

const updatePendingFilter = (e) => {
    const currentFilter = estimateApprovalDataSource.filter();
    if (currentFilter === undefined) {
        const baseFilter = {
            filters: [pendingFilter],
            logic: 'and'
        }
        estimateApprovalDataSource.filter(baseFilter);
        return;
    }
    if (e.target.checked) {
        currentFilter.filters.push(pendingFilter);
    } else { // find index of pending and splice current filters to remove
        const pendingFilterIndex = currentFilter.filters.findIndex(f => f === pendingFilter);
        currentFilter.filters.splice(pendingFilterIndex, 1);
    }
    estimateApprovalDataSource.filter(currentFilter);
};

const updateCreatedFilter = (e) => {
    const currentFilter = estimateApprovalDataSource.filter();
    if (currentFilter === undefined) {
        const baseFilter = {
            filters: [myCreatedFilter],
            logic: 'and'
        }
        estimateApprovalDataSource.filter(baseFilter);
    }
    if (e.target.checked) {
        currentFilter.filters.push(myCreatedFilter);
    } else { // find index of pending and splice current filters to remove
        const filterIndex = currentFilter.filters.findIndex(f => f === myCreatedFilter);
        currentFilter.filters.splice(filterIndex, 1);
    }
    estimateApprovalDataSource.filter(currentFilter);
};

const setupFilters = () => {
    setupPendingApprovalFilter();

    const createdEle = $('input#myCreated');
    createdEle.click(updateCreatedFilter);
    myCreatedFilter.filters.push({
        operator: 'eq',
        field: 'CreatedBy',
        value: $('.js-my-created-filter').val()
    });
};

const setupPendingApprovalFilter = () => {
    const pendingEle = $('input#myPending');
    pendingEle.click(updatePendingFilter);
    const filter = {
        operator: 'contains',
        field: 'PendingApprovals',
        value: $('.js-my-created-filter').val()
    };
    pendingFilter.filters.push(filter);
}

const setupGrid = () => {
    if (isGridInit === true) return;
    estimateApprovalGrid = estimateApprovalGrid.kendoGrid({
        dataSource: estimateApprovalDataSource,
        columns: estimateApprovalColumns,
        dataBound(e) {
            clickableGridRows(e, openEstimateApproval);
        },
        sortable: true,
        filterable: gridSettings.filterable,
        pageable: gridSettings.pageable,
        toolbar: kendo.template($('#template-filter').html()),
        noRecords: {
            template: 'No Estimate Approvals to display.'
        }
    }).data('kendoGrid');
    setupFilters();
    isGridInit = true;
};

const setupNewButton = () => {
    if (isCreateNewInit === true) return;
    const btnEle = $('.js-estimate-approval-new');
    btnEle.on('click', newEstimateApproval);
}

export default function () {
    setupGrid();
    setupNewButton();
}